import { FC, useState } from 'react';

import { Entertainer } from '@queries/EntertainerQueries';

import { UpdateEntertainerPayload } from '@mutations/EntertainerMutations';

import { TitleToolbar } from '@components/layout/TitleToolbar/TitleToolbar';

import { ContactFields } from './ContactFields';
import { LinksListField } from './LinksListField';

interface EntertainerContactInformationFieldsProps {
  entertainer?: Pick<UpdateEntertainerPayload, 'contact'>;
  onChange?: (contact: Entertainer['contact']) => void;
}

export const EntertainerContactInformationFields: FC<EntertainerContactInformationFieldsProps> = ({
  entertainer,
  onChange,
}) => {
  const [contact, setContact] = useState<Entertainer['contact']>(entertainer?.contact ?? {});
  const [links, setLinks] = useState<Entertainer['contact']['links']>(
    entertainer?.contact?.links ?? [],
  );

  const handleContactChange = (updatedValue: Partial<Entertainer['contact']>) => {
    const updated = { ...contact, ...updatedValue };
    setContact(updated);
    onChange?.({ ...updated, links });
  };

  const handleLinksChange = (updatedLinks: Entertainer['contact']['links']) => {
    setLinks(updatedLinks);
    onChange?.({ ...contact, links: updatedLinks });
  };

  return (
    <>
      <TitleToolbar text="Contact Information" size="sm" />

      <ContactFields.Instagram contact={contact} setContact={handleContactChange} />
      <ContactFields.Facebook contact={contact} setContact={handleContactChange} />
      <ContactFields.Email contact={contact} setContact={handleContactChange} />
      <ContactFields.CashApp contact={contact} setContact={handleContactChange} />

      <LinksListField links={links} onChange={handleLinksChange} />
    </>
  );
};
